function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWcFbw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0066FF"
    },
    d: "M113,105H18c-6.6000004,0-12-5.4000015-12-12V25c0-6.6000004,5.3999996-12,12-12h95 c6.5999985,0,12,5.3999996,12,12v68C125,99.5999985,119.5999985,105,113,105z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 79,
    transform: "matrix(0.7071068 0.7071068 -0.7071068 0.7071068 88.7487411 -16.2584057)",
    style: {
      fill: "#0066FF"
    },
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3452_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3454_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3463_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3472_",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FAFAFA"
    },
    d: "M55.6879387,38.9676895 c2.6264381,0,4.7687531-2.1423149,4.7687531-4.7687569c0-2.6266708-2.1423149-4.7689838-4.7687531-4.7689838 c-2.626442,0-4.7687569,2.142313-4.7687569,4.7689838C50.9191818,36.8253746,53.0614967,38.9676895,55.6879387,38.9676895z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3469_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3471_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M55.0481911,86.033905c0,1.7579422-1.15411,3.1830063-2.5779381,3.1830063 c-1.4239197,0-2.5780258-1.4250641-2.5780258-3.1830063V59.1638947c0-1.7579422,1.1541061-3.18293,2.5780258-3.18293 c1.4238281,0,2.5779381,1.4249878,2.5779381,3.18293V86.033905z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3470_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M61.4835739,86.033905c0,1.7579422-1.1545715,3.1830063-2.5784073,3.1830063 c-1.423912,0-2.5780182-1.4250641-2.5780182-3.1830063V59.1638947c0-1.7579422,1.1541061-3.18293,2.5780182-3.18293 c1.4238358,0,2.5784073,1.4249878,2.5784073,3.18293V86.033905z"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3468_",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FAFAFA"
    },
    points: "47.8119164,67.7120514  63.5638847,67.7120514 59.694397,43.0647736 51.6814079,43.0647736  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3467_",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FAFAFA"
    },
    d: "M49.8494072,40.4965744h11.6765213 c1.9718094,0,3.585331,1.6587257,3.585331,3.6850891v3.3534393H46.264534v-3.3534393 C46.264534,42.1548386,47.8776093,40.4965744,49.8494072,40.4965744z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3464_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3466_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M47.4554749,61.908432 c-0.1854706,1.1189651-1.2430382,1.8754272-2.362236,1.6899567c-1.1187325-0.1856232-1.875351-1.2430458-1.6894951-2.362011 l2.8524323-17.2001266c0.1859245-1.1188889,1.243576-1.8755798,2.3622322-1.6898804 c1.1186562,0.1853943,1.875351,1.2430458,1.6898804,2.362011L47.4554749,61.908432z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3465_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M63.9203987,61.908432 c0.1853905,1.1189651,1.2430458,1.8754272,2.3617744,1.6899567c1.11866-0.1856232,1.8752747-1.2430458,1.6898804-2.362011 l-2.85289-17.2001266c-0.1853867-1.1188889-1.243042-1.8755798-2.3617744-1.6898804 c-1.1191177,0.1853943-1.8758087,1.2430458-1.6898804,2.362011L63.9203987,61.908432z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3455_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3462_",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FAFAFA"
    },
    d: "M22.8028316,38.9674568 c2.6268997,0,4.7692146-2.1420822,4.7692146-4.7687531c0-2.626442-2.1423149-4.7689857-4.7692146-4.7689857 c-2.626442,0-4.768755,2.1425438-4.768755,4.7689857C18.0340767,36.8253746,20.1763897,38.9674568,22.8028316,38.9674568z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3461_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M15.6145163,61.5446281c0,1.1342316-0.91922,2.0537605-2.0537605,2.0537605 c-1.1340809,0-2.0533772-0.919529-2.0533772-2.0537605V44.1093788c0-1.134079,0.9192963-2.053299,2.0533772-2.053299 c1.1345406,0,2.0537605,0.91922,2.0537605,2.053299V61.5446281z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3460_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M33.6151543,61.5446281c0,1.1342316-0.9192963,2.0537605-2.0533772,2.0537605 c-1.1340046,0-2.0537605-0.919529-2.0537605-2.0537605V44.1093788c0-1.134079,0.9197559-2.053299,2.0537605-2.053299 c1.1340809,0,2.0533772,0.91922,2.0533772,2.053299V61.5446281z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3459_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M21.9217491,86.033905c0,1.7579422-1.1540318,3.1830063-2.5779438,3.1830063 c-1.4239063,0-2.5779438-1.4250641-2.5779438-3.1830063V59.1638947c0-1.7579422,1.1540375-3.18293,2.5779438-3.18293 c1.423912,0,2.5779438,1.4249878,2.5779438,3.18293V86.033905z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3458_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M28.357132,86.033905c0,1.7579422-1.1544876,3.1830063-2.5784054,3.1830063 c-1.4234505,0-2.5779438-1.4250641-2.5779438-3.1830063V59.1638947c0-1.7579422,1.1544933-3.18293,2.5779438-3.18293 c1.4239178,0,2.5784054,1.4249878,2.5784054,3.18293V86.033905z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_3457_",
    x: 16.7658615,
    y: 45.9842682,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FAFAFA"
    },
    width: 11.5912695,
    height: 17.2477055
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3456_",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FAFAFA"
    },
    d: "M15.0922508,40.4965744h14.9380302 c1.9718056,0,3.5848732,1.6582642,3.5848732,3.6850891v3.3534393H11.5073786v-3.3534393 C11.5073786,42.1548386,13.1204443,40.4965744,15.0922508,40.4965744z"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_3453_",
    x: 38.855835,
    y: 29.4299488,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FAFAFA"
    },
    width: 1.7956976,
    height: 59.7869606
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000010274962090540787950000014464236129783127202_",
    x: 75.3407288,
    y: 29.8013802,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FAFAFA"
    },
    width: 1.7956976,
    height: 59.7869606
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1275_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1282_",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FAFAFA"
    },
    d: "M94.5635757,54.2032967 c2.4010468,0,4.3595123-1.9583969,4.3595123-4.3599396c0-2.4009781-1.9584656-4.3594475-4.3595123-4.3594475 c-2.4012604,0-4.3597336,1.9584694-4.3597336,4.3594475C90.2038422,52.2448997,92.1623154,54.2032967,94.5635757,54.2032967z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1281_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M96.4409485,74.0271225c0,1.0367584-0.8406143,1.8770905-1.8775864,1.8770905 c-1.0367584,0-1.8773041-0.840332-1.8773041-1.8770905V58.0879631c0-1.0367584,0.8405457-1.8771629,1.8773041-1.8771629 c1.036972,0,1.8775864,0.8404045,1.8775864,1.8771629V74.0271225z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1280_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M94.5635757,75.904213c-1.036972,0-1.8775177-0.840332-1.8775177-1.8770905 c0-1.037178,0.8405457-1.8775177,1.8775177-1.8775177h15.938736c1.0367584,0,1.8775864,0.8403397,1.8775864,1.8775177 c0,1.0367584-0.8408279,1.8770905-1.8775864,1.8770905H94.5635757z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1279_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M94.5635757,66.4645233c-1.036972,0-1.8775177-0.8408279-1.8775177-1.8775864 s0.8405457-1.8770943,1.8775177-1.8770943h13.7344589c1.0368271,0,1.8771591,0.8403358,1.8771591,1.8770943 s-0.840332,1.8775864-1.8771591,1.8775864H94.5635757z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1278_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M118.1415863,84.0785294 c0.4983521,0.9093628,0.164856,2.0504379-0.7445145,2.5483627c-0.9094315,0.4983521-2.0500793,0.1652756-2.5484314-0.7440872 l-5.9274597-10.8198395c-0.4982758-0.9088669-0.1651993-2.0500107,0.7441635-2.5483627 c0.9094315-0.4979324,2.0505066-0.164856,2.548851,0.7445068L118.1415863,84.0785294z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1277_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M119.1638184,81.3775864 c0.9094391-0.4983521,2.0505066-0.164856,2.548439,0.7445831c0.4983521,0.9089432,0.164856,2.0500107-0.7440872,2.5483627 l-3.5710983,1.9563599c-0.9094315,0.4983521-2.0500793,0.1652756-2.5484314-0.7440872 c-0.4983521-0.9094315-0.1647873-2.0505066,0.7445068-2.548851L119.1638184,81.3775864z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1276_",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FAFAFA"
    },
    d: "M90.8943405,66.4159088 c-4.3399506,1.3528595-7.4902039,5.4023056-7.4902039,10.1872864c0,5.8925247,4.7767029,10.669014,10.669014,10.669014 c5.5233154,0,10.0664902-4.1967621,10.6138077-9.5760651h3.4173203 c-0.5575562,7.2615128-6.6263657,12.9802017-14.0311279,12.9802017C86.3007278,90.6763458,80,84.3758316,80,76.6031952 c0-6.6791916,4.6529541-12.2713928,10.8943405-13.7123604V66.4159088z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWcFbw);
export default __webpack_public_path__ + "static/media/wc_fbw.a1fe85db928ac18dc7f1dcc1429f70da.svg";
export { ForwardRef as ReactComponent };